'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAVE_SUCCESS = exports.SAVE_FAIL = exports.JOIN_SUCCESS = exports.JOIN_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.activate = activate;
exports.deleteImage = deleteImage;
exports.isLoaded = isLoaded;
exports.isLoading = isLoading;
exports.joinCalendar = joinCalendar;
exports.load = load;
exports.login = login;
exports.loginCode = loginCode;
exports.logout = logout;
exports.register = register;
exports.save = save;
exports.saveImage = saveImage;
exports.updateAvatar = updateAvatar;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTIVATE = 'caligram/auth/ACTIVATE';
var ACTIVATE_FAIL = 'caligram/auth/ACTIVATE_FAIL';
var ACTIVATE_SUCCESS = 'caligram/auth/ACTIVATE_SUCCESS';
var DELETE_IMAGE = 'caligram/auth/DELETE_IMAGE';
var DELETE_IMAGE_FAIL = 'caligram/auth/DELETE_IMAGE_FAIL';
var DELETE_IMAGE_SUCCESS = 'caligram/auth/DELETE_IMAGE_SUCCESS';
var JOIN = 'caligram/auth/JOIN';
var JOIN_FAIL = exports.JOIN_FAIL = 'caligram/auth/JOIN_FAIL';
var JOIN_SUCCESS = exports.JOIN_SUCCESS = 'caligram/auth/JOIN_SUCCESS';
var LOAD = 'caligram/auth/LOAD';
var LOAD_FAIL = 'caligram/auth/LOAD_FAIL';
var LOAD_SUCCESS = 'caligram/auth/LOAD_SUCCESS';
var LOGIN = 'caligram/auth/LOGIN';
var LOGIN_FAIL = 'caligram/auth/LOGIN_FAIL';
var LOGIN_SUCCESS = 'caligram/auth/LOGIN_SUCCESS';
var LOGOUT = 'caligram/auth/LOGOUT';
var LOGOUT_FAIL = 'caligram/auth/LOGOUT_FAIL';
var LOGOUT_SUCCESS = 'caligram/auth/LOGOUT_SUCCESS';
var REGISTER = 'caligram/auth/REGISTER';
var REGISTER_FAIL = 'caligram/auth/REGISTER_FAIL';
var REGISTER_SUCCESS = 'caligram/auth/REGISTER_SUCCESS';
var SAVE = 'caligram/auth/SAVE';
var SAVE_FAIL = exports.SAVE_FAIL = 'caligram/auth/SAVE_FAIL';
var SAVE_SUCCESS = exports.SAVE_SUCCESS = 'caligram/auth/SAVE_SUCCESS';
var SAVE_IMAGE = 'caligram/auth/SAVE_IMAGE';
var SAVE_IMAGE_FAIL = 'caligram/auth/SAVE_IMAGE_FAIL';
var SAVE_IMAGE_SUCCESS = 'caligram/auth/SAVE_IMAGE_SUCCESS';
var UPDATE_AVATAR = 'caligram/auth/UPDATE_AVATAR';

var initialState = {
  error: {},
  loaded: false,
  loading: false,
  selectedEntity: {},
  selectedType: 'user',
  user: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ACTIVATE:
      return (0, _extends3.default)({}, state, {
        error: {},
        loading: true
      });
    case ACTIVATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: false
      });
    case ACTIVATE_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error,
        loading: false,
        user: null
      });
    case JOIN:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case JOIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        error: action.error
      });
    case JOIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false
      });
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result,
        selectedEntity: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        error: {},
        loading: true
      });
    case LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result,
        selectedEntity: action.result
      });
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        user: null,
        status: null,
        error: action.error
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state);
    case LOGOUT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        user: null
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error
      });
    case SAVE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SAVE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result
      });
    case SAVE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error.errors
      });
    case SAVE_IMAGE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SAVE_IMAGE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: (0, _extends3.default)({}, state.user, {
          image: action.result
        })
      });
    case SAVE_IMAGE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case DELETE_IMAGE:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case DELETE_IMAGE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: (0, _extends3.default)({}, state.user, {
          image: null
        })
      });
    case DELETE_IMAGE_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case UPDATE_AVATAR:
      var selectedType = state.selectedType;
      var selectedEntity = state.selectedEntity;


      if (selectedType === 'user') {
        selectedEntity = (0, _extends3.default)({}, selectedEntity, {
          avatar: action.result
        });
      }

      return (0, _extends3.default)({}, state, {
        user: (0, _extends3.default)({}, state.user, {
          avatar: action.result
        }),
        selectedEntity: selectedEntity
      });
    case REGISTER:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case REGISTER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false
      });
    case REGISTER_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error.errors ? action.error.errors : action.error
      });
    default:
      return state;
  }
}

function activate(data) {
  return {
    types: [ACTIVATE, ACTIVATE_SUCCESS, ACTIVATE_FAIL],
    promise: function promise(client) {
      return client.post('/auth/activate', { data: data });
    }
  };
}

function deleteImage(id) {
  return {
    types: [DELETE_IMAGE, DELETE_IMAGE_SUCCESS, DELETE_IMAGE_FAIL],
    promise: function promise(client) {
      return client.del('images/' + id + '?type=user');
    }
  };
}

function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

function isLoading(globalState) {
  return globalState.auth && globalState.auth.loading;
}

function joinCalendar(id, name) {
  return {
    types: [JOIN, JOIN_SUCCESS, JOIN_FAIL],
    promise: function promise(client) {
      return client.post('/calendars/' + id + '/join', { data: { name: name } });
    }
  };
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/users/me');
    }
  };
}

function login(email, password) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/login', {
        data: {
          email: email,
          password: password
        }
      });
    }
  };
}

function loginCode(code) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.get('/login_code?code=' + code);
    }
  };
}

function logout() {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: function promise(client) {
      return client.get('/logout');
    }
  };
}

function register(payload) {
  return {
    types: [REGISTER, REGISTER_SUCCESS, REGISTER_FAIL],
    promise: function promise(client) {
      return client.post('/auth/register', {
        data: payload
      });
    }
  };
}

function save(payload) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.put('/users/me', {
        data: payload
      });
    }
  };
}

function saveImage(image) {
  return {
    types: [SAVE_IMAGE, SAVE_IMAGE_SUCCESS, SAVE_IMAGE_FAIL],
    promise: function promise(client) {
      return client.post('images?type=user', {
        image: image
      });
    }
  };
}

function updateAvatar(avatar) {
  return {
    type: UPDATE_AVATAR,
    result: avatar
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 111
// module chunks = 0